import React from 'react';
import { Box, CircularProgress } from '@mui/material';

interface LoadingProps {
    width?: string;
    height?: string;
    size?: number;
}

export function Loading({ width, height, size }: LoadingProps) { 
    return (
      <Box
        sx={{
          display: 'flex',
          width: width ? width : '100%',
          height: height ? height : '100vh',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
        <CircularProgress
          size={size ? size : 100}
          aria-label='loading'
        />
      </Box>
    );
}